<template>
  <div class="subcat-select__entry">
    <div class="subcat-select__label">
      <div v-if="data.children != null" class="subcat-select__expando">
        <button @click.prevent="collapse()" class="subcat-select__collapse-button" v-text="collapsed ? '+' : '-'"></button>
        <label>{{data.label}}</label>
      </div>
      <div v-else class="checkbox">
        <input type="checkbox" :id="`id_${id}_${data.id}`" :name="name" :value="data.id" :checked="isChecked(data.id)">
        <label :for="`id_${id}_${data.id}`">{{data.label}}</label>
      </div>
      <div class="help-box-container" title="Opis">
        <a v-if="data.note" href="javascript:;" @click.prevent
          class="help-box"
          data-toggle="popover"
          data-trigger="click"
          data-placement="top"
          :data-content="formatNote"
          data-html="true"
        >?</a>
      </div>
      <div class="help-box-container" title="Dovoljenja">
        <a v-if="data.permissions" href="javascript:;" @click.prevent
          class="help-box"
          data-toggle="popover"
          data-trigger="click"
          data-placement="top"
          :data-content="formatPermissions"
          data-html="true"
        >!</a>
      </div>
    </div>
    <div v-if="data.children != null" v-show="!collapsed" :class="['subcat-select__children', {'subcat-select__children--collapsed': collapsed}]">
      <subcat-entry v-for="option in data.children" :key="option.id" :data="option" :name="name" :values="values" :id="id" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'subcat-entry',
  props: {
    data: { type: Object, required: true },
    name: { type: String, required: true },
    id: { type: String, required: true },
    values: { type: Array, required: true },
  },
  computed: {
    formatNote() {
      return this.data.note ? this.data.note.replace(/(?:\r\n|\r|\n)/g, '<br>') : '';
    },
    formatPermissions() {
      return this.data.permissions ? this.data.permissions.replace(/(?:\r\n|\r|\n)/g, '<br>') : '';
    },
  },
  methods: {
    isChecked() {
      const checked = this.values && this.values.indexOf(this.data.id) !== -1;
      if (checked) {
        let parent = this.$parent;
        while (parent) {
          parent.collapsed = false;
          parent = parent.$parent;
        }
      }
      return checked;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/epravnik/widgets/SubcatEntry.vue